module.exports = __webpack_public_path__ + "static/media/home-understand-key-drivers.6ecfa81e.png";